(function () {
  var gallerySelector = '[data-jci-gallery]';
  var selectorRootSelector = '[data-jci-initial-pack-size]';
  var modalSelector = '[data-jci-modal]';
  var stickyAtcSelector = '[data-jci-sticky-atc]';
  var cartCountSelector = '[data-jci-cart-count]';
  var deliveryEstimateSelector = '[data-jci-delivery-estimate]';
  var upCartEvents = [
    'aftersell-upcart:public-events:added-to-cart',
    'aftersell-upcart:public-events:cart-updated',
    'aftersell-upcart:public-events:item-removed'
  ];

  function setCartCount(count) {
    document.querySelectorAll(cartCountSelector).forEach(function (node) {
      var template = node.dataset.jciCartCountTemplate || 'Cart([count])';

      node.textContent = template.replace('[count]', count);
    });

    document.querySelectorAll('#dw-header-cart-link .cart-count, #cart-icon-bubble .cart-count').forEach(function (node) {
      node.textContent = count;
    });

    document.querySelectorAll('#dw-header-cart-link .cart-count-bubble span[aria-hidden="true"], #cart-icon-bubble .cart-count-bubble span[aria-hidden="true"]').forEach(function (node) {
      if (node.querySelector('.cart-count')) return;
      node.textContent = '(' + count + ')';
    });
  }

  function refreshCartCount() {
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';

    return fetch(cartUrl + '.js', {
      method: 'GET',
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store'
    })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (cart) {
        if (cart && typeof cart.item_count === 'number') setCartCount(cart.item_count);
      })
      .catch(function () {});
  }

  function initCartCount() {
    var docElement = document.documentElement;

    if (docElement.dataset.jciCartCountInitialized === 'true') return;
    docElement.dataset.jciCartCountInitialized = 'true';

    upCartEvents.forEach(function (eventName) {
      window.addEventListener(eventName, function () {
        refreshCartCount();
      });
    });

    window.addEventListener('pageshow', function (event) {
      if (event.persisted) refreshCartCount();
    });
  }

  function deliveryDateFromSettings(days, includeWeekend) {
    var result = new Date();
    var remainingDays = Number(days) || 0;

    result = new Date(result.getFullYear(), result.getMonth(), result.getDate());

    if (includeWeekend) {
      result.setDate(result.getDate() + remainingDays);
      return result;
    }

    while (remainingDays > 0) {
      result.setDate(result.getDate() + 1);

      if (result.getDay() !== 0 && result.getDay() !== 6) {
        remainingDays -= 1;
      }
    }

    return result;
  }

  function formatDeliveryDate(date) {
    try {
      return new Intl.DateTimeFormat('en-US', {
        weekday: 'short',
        month: 'short',
        day: 'numeric'
      }).format(date);
    } catch (error) {
      return '';
    }
  }

  function handleize(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/([^\w]+|\s+)/g, '-')
      .replace(/\-\-+/g, '-')
      .replace(/(^-+|-+$)/g, '')
      .toLowerCase();
  }

  function initDeliveryEstimate(node) {
    if (!node) return;

    var dateNode = node.querySelector('[data-jci-delivery-date]');
    var includeWeekend = node.dataset.jciDeliveryIncludeWeekend === 'true';
    var formattedDate = formatDeliveryDate(deliveryDateFromSettings(node.dataset.jciDeliveryDays, includeWeekend));

    if (dateNode && formattedDate) dateNode.textContent = formattedDate;
  }

  function initStickyAtc(sticky) {
    if (!sticky || sticky.dataset.jciStickyAtcInitialized === 'true') return;

    var root = sticky.closest('.jci-pdp');
    var button = sticky.querySelector('[data-jci-sticky-atc-button]');
    var label = sticky.querySelector('[data-jci-sticky-atc-label]');
    var price = sticky.querySelector('[data-jci-sticky-atc-price]');
    var priceWrap = sticky.querySelector('[data-jci-sticky-atc-price-wrap]');
    var mainButton = root ? root.querySelector('[data-jci-add-to-cart]') : null;
    var flavorTarget = root ? root.querySelector('[data-jci-flavor-card]') : null;
    var emptyLabel = mainButton && mainButton.dataset.jciStickyEmptyLabel ? mainButton.dataset.jciStickyEmptyLabel : 'Select Your Flavors';
    var addLabel = mainButton && mainButton.dataset.jciAddLabel ? mainButton.dataset.jciAddLabel : 'Add to Cart';
    var hasSelection = false;
    var isAdding = false;

    if (!root || !button || !mainButton) return;

    sticky.dataset.jciStickyAtcInitialized = 'true';

    function scrollToSelector() {
      var target = flavorTarget ? flavorTarget.closest('.jci-pdp__block') || flavorTarget : root;

      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    function updateVisibility() {
      var shouldShow = root.getBoundingClientRect().bottom <= 0;

      sticky.classList.toggle('is-visible', shouldShow);
      sticky.setAttribute('aria-hidden', String(!shouldShow));
      button.tabIndex = shouldShow ? 0 : -1;
    }

    function updateFromSelection(event) {
      var detail = event && event.detail ? event.detail : {};
      var subscriptionPrice = root.querySelector('[data-jci-subscription-total]');

      hasSelection = Number(detail.totalQuantity || 0) > 0;
      isAdding = mainButton.disabled && mainButton.textContent.trim().toLowerCase().indexOf('adding') !== -1;

      button.classList.toggle('is-empty', !hasSelection);
      button.disabled = isAdding;

      if (!hasSelection) {
        if (label) label.textContent = emptyLabel;
        if (price) price.hidden = true;
        if (priceWrap) priceWrap.hidden = true;
        return;
      }

      if (label) label.textContent = addLabel;
      if (price && subscriptionPrice) {
        price.textContent = subscriptionPrice.textContent.trim();
        price.hidden = !price.textContent;
        if (priceWrap) priceWrap.hidden = !price.textContent;
      }
    }

    button.addEventListener('click', function () {
      if (!hasSelection) {
        scrollToSelector();
        return;
      }

      if (!mainButton.disabled) mainButton.click();
    });

    root.addEventListener('jci:pdp-selection-change', updateFromSelection);
    window.addEventListener('scroll', updateVisibility, { passive: true });
    window.addEventListener('resize', updateVisibility);

    updateFromSelection({ detail: { totalQuantity: Number(root.dataset.jciSelectedTotal || 0) } });
    updateVisibility();
  }

  var isSyncingVariantOptionSelects = false;

  function matchingOptionForValue(select, optionValue) {
    var value = handleize(optionValue);

    if (!select || !value) return null;

    return Array.prototype.slice.call(select.options).find(function (option) {
      return handleize(option.value) === value || handleize(option.textContent) === value;
    }) || null;
  }

  function productImageTextFlavorHandles() {
    var handles = {};
    var prefix = 'show-on--variant-option--flavor--';

    document.querySelectorAll('.shopify-section--product-image-text [class*="' + prefix + '"]').forEach(function (element) {
      Array.prototype.slice.call(element.classList).forEach(function (className) {
        if (className.indexOf(prefix) !== 0) return;
        handles[className.slice(prefix.length)] = true;
      });
    });

    return handles;
  }

  function filterProductImageTextFlavorSelects(scope) {
    var context = scope || document;
    var handles = productImageTextFlavorHandles();
    var hasKnownFlavors = Object.keys(handles).length > 0;

    context.querySelectorAll('.shopify-section--product-image-text select[data-dw-select][name="options[Flavor]"]').forEach(function (select) {
      var fakeSelect = select.nextElementSibling && select.nextElementSibling.classList.contains('dw-select')
        ? select.nextElementSibling
        : null;
      var firstAvailable = null;

      Array.prototype.slice.call(select.options).forEach(function (option) {
        var optionHandle = handleize(option.value || option.textContent);
        var isAvailable = !hasKnownFlavors || Boolean(handles[optionHandle]);
        var fakeOption = fakeSelect
          ? Array.prototype.slice.call(fakeSelect.querySelectorAll('.dw-select--value[data-dw-select-value]')).find(function (item) {
            return handleize(item.dataset.dwSelectValue || item.textContent) === optionHandle;
          })
          : null;

        option.disabled = !isAvailable;
        option.hidden = !isAvailable;

        if (fakeOption) {
          fakeOption.hidden = !isAvailable;
          fakeOption.style.display = isAvailable ? '' : 'none';
          fakeOption.setAttribute('aria-hidden', String(!isAvailable));
        }

        if (isAvailable && !firstAvailable) firstAvailable = option;
      });

      if (select.selectedOptions[0] && select.selectedOptions[0].disabled && firstAvailable) {
        select.value = firstAvailable.value;

        if (fakeSelect) {
          var button = fakeSelect.querySelector('.dw-select--button');
          if (button) {
            button.dataset.dwSelectValue = firstAvailable.value;
            button.textContent = firstAvailable.textContent;
          }
        }
      }
    });
  }

  function syncVariantOptionSelects(optionName, optionValue) {
    var selector = 'select[data-dw-select][name="options[' + optionName + ']"]';

    isSyncingVariantOptionSelects = true;

    try {
      document.querySelectorAll(selector).forEach(function (select) {
        var option = matchingOptionForValue(select, optionValue);

        if (!option || select.value === option.value) return;

        select.value = option.value;
        select.dispatchEvent(new Event('change'));
      });
    } finally {
      isSyncingVariantOptionSelects = false;
    }
  }

  function toggleVariantOptionSections(optionName, optionValue) {
    var name = handleize(optionName);
    var value = handleize(optionValue);

    document.querySelectorAll('[class*="show-on--variant-option--' + name + '--"]').forEach(function (element) {
      var shouldShow = Boolean(value) && element.classList.contains('show-on--variant-option--' + name + '--' + value);
      var parentSection;

      element.style.display = shouldShow ? '' : 'none';

      if (element.classList.contains('show-on--start-with-parent-section')) {
        parentSection = element.closest('.shopify-section');
        if (parentSection) parentSection.style.display = shouldShow ? '' : 'none';
      }
    });
  }

  function syncVariantOption(optionName, optionValue) {
    toggleVariantOptionSections(optionName, optionValue);
    syncVariantOptionSelects(optionName, optionValue);
  }

  function initVariantOptionSelectSync(scope) {
    var context = scope || document;

    filterProductImageTextFlavorSelects(context);

    context.querySelectorAll('select[data-dw-select][name="options[Flavor]"]').forEach(function (select) {
      if (select.dataset.jciFlavorSyncInitialized === 'true') return;

      select.dataset.jciFlavorSyncInitialized = 'true';
      select.addEventListener('change', function () {
        if (isSyncingVariantOptionSelects) return;

        syncVariantOption('Flavor', select.value);
        document.dispatchEvent(new CustomEvent('jci:pdp-flavor-option-change', {
          detail: {
            flavor: select.value,
            sourceSelect: select
          }
        }));
      });
    });
  }

  function initGallery(gallery) {
    if (!gallery || gallery.dataset.jciGalleryInitialized === 'true') return;

    var heroMedia = gallery.querySelector('[data-jci-gallery-hero-media]');
    var status = gallery.querySelector('[data-jci-gallery-status]');
    var track = gallery.querySelector('[data-jci-gallery-track]');
    var prevButton = gallery.querySelector('[data-jci-gallery-prev]');
    var nextButton = gallery.querySelector('[data-jci-gallery-next]');
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-jci-gallery-thumb]'));
    var visibleThumbs = thumbs.slice();

    if (!heroMedia || !thumbs.length) return;

    gallery.dataset.jciGalleryInitialized = 'true';

    function ensureHeroImage() {
      var image = heroMedia.querySelector('.jci-pdp__hero-image');

      if (image) return image;

      heroMedia.textContent = '';
      image = document.createElement('img');
      image.className = 'jci-pdp__hero-image';
      image.loading = 'eager';
      image.decoding = 'async';
      heroMedia.appendChild(image);

      return image;
    }

    function playHeroMedia() {
      var video = heroMedia.querySelector('video');

      if (!video) return;

      video.muted = true;
      video.play().catch(function () {});
    }

    function indexOfActiveThumb() {
      var activeIndex = visibleThumbs.findIndex(function (thumb) {
        return thumb.classList.contains('is-active') || thumb.getAttribute('aria-current') === 'true';
      });

      return activeIndex >= 0 ? activeIndex : 0;
    }

    function updateArrows(activeIndex) {
      if (prevButton) {
        prevButton.disabled = activeIndex <= 0;
        prevButton.setAttribute('aria-disabled', String(activeIndex <= 0));
      }

      if (nextButton) {
        nextButton.disabled = activeIndex >= visibleThumbs.length - 1;
        nextButton.setAttribute('aria-disabled', String(activeIndex >= visibleThumbs.length - 1));
      }
    }

    function announce(thumb, activeIndex) {
      if (!status || !thumb) return;
      status.textContent = 'Product image ' + (activeIndex + 1) + ' of ' + visibleThumbs.length + ' selected';
    }

    function setHeroFromDataset(source) {
      var template = source && typeof source.querySelector === 'function' ? source.querySelector('[data-jci-gallery-template]') : null;
      var heroImage;

      if (!source || !source.dataset.jciFullSrc) return;

      if (template) {
        if (typeof window.pauseAllMedia === 'function') window.pauseAllMedia();
        heroMedia.textContent = '';
        heroMedia.appendChild(template.content.cloneNode(true));
        playHeroMedia();
        return;
      }

      if (typeof window.pauseAllMedia === 'function') window.pauseAllMedia();
      heroImage = ensureHeroImage();
      heroImage.src = source.dataset.jciFullSrc;
      if (source.dataset.jciSrcset) heroImage.srcset = source.dataset.jciSrcset;
      if (source.dataset.jciSizes) heroImage.sizes = source.dataset.jciSizes;
      if (source.dataset.jciAlt !== undefined) heroImage.alt = source.dataset.jciAlt;
    }

    function setActiveThumb(thumb, options) {
      var activeIndex = visibleThumbs.indexOf(thumb);
      if (activeIndex < 0) return;

      thumbs.forEach(function (item) {
        item.classList.remove('is-active');
        item.removeAttribute('aria-current');
      });

      thumb.classList.add('is-active');
      thumb.setAttribute('aria-current', 'true');
      gallery.dataset.jciActiveMediaId = thumb.dataset.jciMediaId || '';
      gallery.dataset.jciGallerySource = options && options.source ? options.source : thumb.dataset.jciMediaSource || 'product_media';

      setHeroFromDataset(thumb);
      updateArrows(activeIndex);
      announce(thumb, activeIndex);

      if ((!options || options.scroll !== false) && track) {
        track.scrollTo({ left: thumb.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      }

      gallery.dispatchEvent(new CustomEvent('jci:pdp-gallery-media-change', {
        bubbles: true,
        detail: {
          mediaId: thumb.dataset.jciMediaId || null,
          source: gallery.dataset.jciGallerySource,
          variantIds: thumb.dataset.jciVariantIds ? thumb.dataset.jciVariantIds.split(',').filter(Boolean) : []
        }
      }));
    }

    function setActiveByMediaId(mediaId, fallbackSource) {
      var id = String(mediaId || '');
      var thumb = thumbs.find(function (item) {
        return item.dataset.jciMediaId === id;
      });

      if (thumb && !thumb.hidden) {
        setActiveThumb(thumb, {
          source: fallbackSource ? fallbackSource.dataset.jciMediaSource : null
        });
        return true;
      }

      if (fallbackSource && fallbackSource.dataset.jciFullSrc) {
        setHeroFromDataset(fallbackSource);
        gallery.dataset.jciActiveMediaId = id;
        gallery.dataset.jciGallerySource = fallbackSource.dataset.jciMediaSource || 'external_media';
      }

      return false;
    }

    function fallbackSourceFromDetail(detail) {
      if (!detail || !detail.fullSrc) return null;

      return {
        dataset: {
          jciFullSrc: detail.fullSrc,
          jciSrcset: detail.srcset || '',
          jciSizes: detail.sizes || '',
          jciAlt: detail.alt || '',
          jciMediaSource: detail.source || 'variant_media'
        }
      };
    }

    function setGalleryFlavor(flavor, preferredMediaId, fallbackSource) {
      var flavorHandle = handleize(flavor);

      gallery.dataset.jciActiveFlavorHandle = flavorHandle;
      visibleThumbs = thumbs.filter(function (thumb) {
        var mediaFlavor = thumb.dataset.jciMediaFlavorHandle || '';
        var isVisible = !flavorHandle || mediaFlavor === flavorHandle;

        thumb.hidden = !isVisible;
        return isVisible;
      });

      thumbs.forEach(function (thumb) {
        if (!thumb.hidden) return;
        thumb.classList.remove('is-active');
        thumb.removeAttribute('aria-current');
      });

      if (!visibleThumbs.length) {
        updateArrows(0);
        if (fallbackSource) {
          setHeroFromDataset(fallbackSource);
          gallery.dataset.jciActiveMediaId = String(preferredMediaId || '');
          gallery.dataset.jciGallerySource = fallbackSource.dataset.jciMediaSource || 'external_media';
        }
        return;
      }

      if (preferredMediaId && setActiveByMediaId(preferredMediaId, fallbackSource)) return;

      setActiveThumb(visibleThumbs[0], { scroll: false, source: 'flavor_filter' });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        setActiveThumb(thumb);
      });
    });

    var swipeStart = null;

    heroMedia.addEventListener('pointerdown', function (event) {
      if (!event.isPrimary) {
        swipeStart = null;
        return;
      }
      if (event.pointerType === 'mouse' || visibleThumbs.length < 2) return;
      swipeStart = { id: event.pointerId, x: event.clientX, y: event.clientY };
    });

    heroMedia.addEventListener('pointerup', function (event) {
      if (!swipeStart || event.pointerId !== swipeStart.id) return;
      var deltaX = event.clientX - swipeStart.x;
      var deltaY = event.clientY - swipeStart.y;
      swipeStart = null;
      if (Math.abs(deltaX) < 40 || Math.abs(deltaX) <= Math.abs(deltaY) * 1.25) return;
      var nextIndex = indexOfActiveThumb() + (deltaX < 0 ? 1 : -1);
      if (nextIndex >= 0 && nextIndex < visibleThumbs.length) {
        setActiveThumb(visibleThumbs[nextIndex]);
      }
    });

    heroMedia.addEventListener('pointercancel', function () {
      swipeStart = null;
    });

    if (prevButton) {
      prevButton.addEventListener('click', function () {
        var activeIndex = indexOfActiveThumb();
        if (activeIndex > 0) setActiveThumb(visibleThumbs[activeIndex - 1]);
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function () {
        var activeIndex = indexOfActiveThumb();
        if (activeIndex < visibleThumbs.length - 1) setActiveThumb(visibleThumbs[activeIndex + 1]);
      });
    }

    document.querySelectorAll('[data-jci-media-id][data-jci-media-source="flavor"], [data-jci-media-id][data-jci-media-source="pack_size"]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        setActiveByMediaId(trigger.dataset.jciMediaId, trigger);
      });
    });

    gallery.addEventListener('jci:pdp-last-added-variant', function (event) {
      if (!event.detail) return;
      if (event.detail.flavor) {
        setGalleryFlavor(event.detail.flavor, event.detail.mediaId, fallbackSourceFromDetail(event.detail));
        return;
      }
      if (event.detail.mediaId) {
        var fallbackSource = fallbackSourceFromDetail(event.detail);
        setActiveByMediaId(event.detail.mediaId, fallbackSource);
        return;
      }

      if (!event.detail.variantId) return;
      var variantId = String(event.detail.variantId);
      var thumb = thumbs.find(function (item) {
        return item.dataset.jciVariantIds && item.dataset.jciVariantIds.split(',').indexOf(variantId) !== -1;
      });

      if (thumb) setActiveThumb(thumb);
    });

    setActiveThumb(thumbs[indexOfActiveThumb()], { scroll: false });
    if (track) track.scrollLeft = thumbs[indexOfActiveThumb()].offsetLeft - track.offsetLeft;
  }

  function readPdpData(root) {
    var script = root.querySelector('[data-jci-pdp-data]');
    if (!script) return null;

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return null;
    }
  }

  function formatMoney(cents, moneyFormat) {
    var format = moneyFormat || '${{amount}}';
    var placeholder = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var placeholderName = placeholder ? placeholder[1] : 'amount';

    function formatWithDelimiters(number, precision, thousands, decimal) {
      var value = Number(number || 0);
      var fixed;
      var parts;

      precision = precision === undefined ? 2 : precision;
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;

      if (Number.isNaN(value)) return '0';

      fixed = (value / 100).toFixed(precision);
      parts = fixed.split('.');

      return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands) + (parts[1] ? decimal + parts[1] : '');
    }

    var value = formatWithDelimiters(cents, 2);
    if (placeholderName === 'amount_no_decimals') value = formatWithDelimiters(cents, 0);
    if (placeholderName === 'amount_with_comma_separator') value = formatWithDelimiters(cents, 2, '.', ',');
    if (placeholderName === 'amount_no_decimals_with_comma_separator') value = formatWithDelimiters(cents, 0, '.', ',');

    return placeholder ? format.replace(placeholder[0], value) : value;
  }

  function mediaPayloadFromVariant(variant) {
    if (!variant || !variant.featured_media_id) return {};
    return {
      mediaId: String(variant.featured_media_id),
      variantId: String(variant.id),
      flavor: variant.flavor || '',
      fullSrc: variant.featured_media_full_image || null,
      srcset: variant.featured_media_gallery_srcset || null,
      sizes: '(min-width: 750px) 50vw, 100vw',
      alt: variant.featured_media_alt || '',
      source: variant.is_special_product ? 'special_product' : 'variant_media'
    };
  }

  function initSelector(root) {
    if (!root || root.dataset.jciSelectorInitialized === 'true') return;

    var data = readPdpData(root);
    var variants = data && Array.isArray(data.variants) ? data.variants : [];
    var specialVariants = data && Array.isArray(data.special_variants) ? data.special_variants : [];
    var packCards = Array.prototype.slice.call(root.querySelectorAll('[data-jci-pack-card]'));
    var flavorCards = Array.prototype.slice.call(root.querySelectorAll('[data-jci-flavor-card]'));
    var gallery = root.querySelector(gallerySelector);
    var status = root.querySelector('[data-jci-selector-status]');
    var unitPill = root.querySelector('[data-jci-unit-price-pill]');
    var totalItems = root.querySelector('[data-jci-total-items]');
    var oneTimeTotal = root.querySelector('[data-jci-one-time-total]');
    var totalSavings = root.querySelector('[data-jci-total-savings]');
    var savingsRow = root.querySelector('[data-jci-savings-row]');
    var totalLabel = root.querySelector('[data-jci-total-label]');
    var savingsLabel = root.querySelector('[data-jci-savings-label]');
    var summaryUnitPrice = root.querySelector('[data-jci-summary-unit-price]');
    var purchaseRoot = root.querySelector('[data-jci-purchase]');
    var purchaseButtons = Array.prototype.slice.call(root.querySelectorAll('[data-jci-purchase-mode]'));
    var sellingPlanSelect = root.querySelector('[data-jci-selling-plan-select]');
    var planDropdown = root.querySelector('[data-jci-plan-dropdown]');
    var planDropdownToggle = root.querySelector('[data-jci-plan-dropdown-toggle]');
    var planDropdownMenu = root.querySelector('[data-jci-plan-dropdown-menu]');
    var planDropdownCurrent = root.querySelector('[data-jci-plan-dropdown-current]');
    var planDropdownOptions = Array.prototype.slice.call(root.querySelectorAll('[data-jci-plan-dropdown-option]'));
    var deliveryControl = root.querySelector('[data-jci-delivery-control]');
    var subscriptionRibbon = root.querySelector('[data-jci-subscription-ribbon]');
    var subscriptionBenefitSavings = root.querySelector('[data-jci-subscription-benefit-savings]');
    var giftPanel = root.querySelector('[data-jci-gift-panel]');
    var giftOptions = Array.prototype.slice.call(root.querySelectorAll('[data-jci-gift-option]'));
    var addButton = root.querySelector('[data-jci-add-to-cart]');
    var cartMessage = root.querySelector('[data-jci-cart-message]');
    var selectedSummary = root.querySelector('[data-jci-selected-summary]');
    var selectedSummaryItems = root.querySelector('[data-jci-selected-summary-items]');
    var allowedPackUnits = data && data.computed && Array.isArray(data.computed.allowed_pack_units)
      ? data.computed.allowed_pack_units.map(Number)
      : [12, 24];
    var moneyFormat = data && data.shop ? data.shop.money_format : null;
    var cartRoutes = data && data.purchase ? data.purchase.routes : {};

    if (!flavorCards.length) return;

    variants = variants.concat(specialVariants);

    function purchaseCopy(name, fallback) {
      if (!purchaseRoot || !purchaseRoot.dataset) return fallback;
      return purchaseRoot.dataset[name] || fallback;
    }

    function copyWithValue(template, key, value) {
      return String(template || '').replace(key, value);
    }

    function subscriptionPlansFromVariants(sourceVariants) {
      var plans = [];

      sourceVariants.forEach(function (variant) {
        var allocations = variant && Array.isArray(variant.selling_plan_allocations)
          ? variant.selling_plan_allocations
          : [];

        allocations.forEach(function (allocation) {
          if (!allocation.selling_plan_id) return;
          if (plans.some(function (plan) {
            return Number(plan.id) === Number(allocation.selling_plan_id);
          })) return;

          plans.push({
            id: allocation.selling_plan_id,
            name: allocation.selling_plan_name || ''
          });
        });
      });

      return plans;
    }

    var skioPlans = subscriptionPlansFromVariants(variants);

    root.dataset.jciSelectorInitialized = 'true';

    var activePackCard = packCards.find(function (card) {
      return card.classList.contains('is-active') || card.getAttribute('aria-pressed') === 'true';
    });
    var state = {
      selectedPack: root.dataset.jciInitialPackSize || (activePackCard ? activePackCard.dataset.jciPackSize : ''),
      activeFlavor: '',
      quantitiesByFlavor: {},
      selectedItems: [],
      totalQuantity: 0,
      pricing: {},
      purchase: {
        mode: skioPlans.length ? 'subscription' : 'one_time',
        sellingPlanId: sellingPlanSelect && sellingPlanSelect.value ? Number(sellingPlanSelect.value) : null,
        giftVariantId: null,
        giftTitle: ''
      },
      lastAdded: null,
      isAdding: false
    };
    var activeGiftOption = giftOptions.find(function (option) {
      return option.classList.contains('is-active') || option.getAttribute('aria-pressed') === 'true';
    });
    if (activeGiftOption) {
      state.purchase.giftVariantId = activeGiftOption.dataset.jciGiftVariantId ? Number(activeGiftOption.dataset.jciGiftVariantId) : null;
      state.purchase.giftTitle = activeGiftOption.dataset.jciGiftTitle || '';
    }

    function variantFor(flavor, packSize) {
      return variants.find(function (variant) {
        if (packSize) return variant.flavor === flavor && variant.pack_size === packSize;
        return String(variant.id) === String(flavor);
      }) || null;
    }

    function isAllowedPack(card) {
      return allowedPackUnits.indexOf(Number(card.dataset.jciPackUnits || 0)) !== -1;
    }

    function selectedVariantForCard(card) {
      var flavor = card.dataset.jciFlavor || '';
      var packSize = card.dataset.jciFixedPackSize || state.selectedPack;
      var variant;

      if (card.dataset.jciSpecialProduct === 'true' && card.dataset.jciVariantId) {
        return variants.find(function (item) {
          return String(item.id) === String(card.dataset.jciVariantId);
        }) || null;
      }

      variant = variantFor(flavor, packSize);

      if (!variant && card.dataset.jciVariantId) {
        variant = variants.find(function (item) {
          return String(item.id) === String(card.dataset.jciVariantId);
        }) || null;
      }

      return variant;
    }

    function variantFromUrl() {
      var params;
      var variantParam;
      var skuParam;

      try {
        params = new URLSearchParams(window.location.search || '');
      } catch (error) {
        return null;
      }

      variantParam = params.get('variant');
      skuParam = params.get('sku');

      if (variantParam) {
        var byVariant = variants.find(function (variant) {
          return String(variant.id) === String(variantParam) || String(variant.sku || '') === String(variantParam);
        });

        if (byVariant) return byVariant;
      }

      if (skuParam) {
        return variants.find(function (variant) {
          return String(variant.sku || '') === String(skuParam);
        }) || null;
      }

      return null;
    }

    function updateUrlForVariant(variant) {
      var url;

      if (!variant || !variant.id || !window.history || !window.history.replaceState) return;

      try {
        url = new URL(window.location.href);
      } catch (error) {
        return;
      }

      url.searchParams.set('variant', variant.id);
      url.searchParams.delete('sku');
      window.history.replaceState(null, '', url.toString());
    }

    var initialUrlVariant = variantFromUrl();

    if (
      initialUrlVariant &&
      !initialUrlVariant.is_special_product &&
      initialUrlVariant.pack_size &&
      isAllowedPackUnits(initialUrlVariant.pack_units)
    ) {
      state.selectedPack = initialUrlVariant.pack_size;
    }

    if (initialUrlVariant && initialUrlVariant.available) {
      state.activeFlavor = initialUrlVariant.flavor || '';
      state.quantitiesByFlavor[initialUrlVariant.flavor] = 1;
      state.lastAdded = {
        flavor: initialUrlVariant.flavor,
        pack_size: initialUrlVariant.pack_size,
        variant_id: initialUrlVariant.id,
        sku: initialUrlVariant.sku || '',
        media_id: initialUrlVariant.featured_media_id || null
      };
      updateUrlForVariant(initialUrlVariant);
    }

    function cardForVariant(variant) {
      if (!variant) return null;

      return flavorCards.find(function (card) {
        if (card.dataset.jciSpecialProduct === 'true') {
          return String(card.dataset.jciVariantId || '') === String(variant.id);
        }

        return card.dataset.jciFlavor === variant.flavor;
      }) || null;
    }

    function galleryPayloadForVariant(variant, card) {
      var payload = mediaPayloadFromVariant(variant);
      payload.flavor = variant && variant.flavor ? variant.flavor : card && card.dataset.jciFlavor ? card.dataset.jciFlavor : '';

      if ((!payload.fullSrc || !payload.mediaId) && card && card.dataset.jciFullSrc) {
        payload.mediaId = card.dataset.jciMediaId || payload.mediaId || '';
        payload.fullSrc = card.dataset.jciFullSrc;
        payload.srcset = card.dataset.jciSrcset || payload.srcset || '';
        payload.sizes = card.dataset.jciSizes || payload.sizes || '';
        payload.alt = card.dataset.jciAlt || payload.alt || '';
        payload.source = card.dataset.jciMediaSource || payload.source || 'flavor';
      }

      return payload;
    }

    function cardForFlavor(flavor) {
      var flavorHandle = handleize(flavor);

      if (!flavorHandle) return null;

      return flavorCards.find(function (card) {
        return handleize(card.dataset.jciFlavor || '') === flavorHandle;
      }) || null;
    }

    function syncGalleryToVariant(variant) {
      if (!gallery || !variant) return;

      gallery.dispatchEvent(new CustomEvent('jci:pdp-last-added-variant', {
        bubbles: true,
        detail: galleryPayloadForVariant(variant, cardForVariant(variant))
      }));
    }

    function setActiveFlavorUrlFromCard(card) {
      var variant = selectedVariantForCard(card);
      if (!variant) return;

      state.activeFlavor = variant.flavor || card.dataset.jciFlavor || '';
      state.quantitiesByFlavor = {};
      state.quantitiesByFlavor[state.activeFlavor] = 1;
      state.lastAdded = {
        flavor: state.activeFlavor,
        pack_size: variant.pack_size || card.dataset.jciFixedPackSize || state.selectedPack,
        variant_id: variant.id,
        sku: variant.sku || '',
        media_id: variant.featured_media_id || null
      };
      render();
      updateUrlForVariant(variant);
      syncGalleryToVariant(variant);
    }

    function setHidden(element, shouldHide) {
      if (!element) return;
      element.hidden = shouldHide;
    }

    function isAllowedPackUnits(units) {
      return allowedPackUnits.indexOf(Number(units || 0)) !== -1;
    }

    function bestSellingPlanAllocation(variant) {
      var allocations = variant && Array.isArray(variant.selling_plan_allocations)
        ? variant.selling_plan_allocations
        : [];

      return allocations.reduce(function (bestAllocation, allocation) {
        if (!bestAllocation) return allocation;
        if (Number(allocation.unit_price || allocation.price || 0) < Number(bestAllocation.unit_price || bestAllocation.price || 0)) return allocation;
        return bestAllocation;
      }, null);
    }

    function matchingSpecialSellingPlanAllocation(variant, sellingPlanId) {
      var allocations = variant && Array.isArray(variant.selling_plan_allocations)
        ? variant.selling_plan_allocations
        : [];
      var sourceAllocation = null;

      variants.some(function (productVariant) {
        var productAllocations = productVariant && Array.isArray(productVariant.selling_plan_allocations)
          ? productVariant.selling_plan_allocations
          : [];

        sourceAllocation = productAllocations.find(function (allocation) {
          return Number(allocation.selling_plan_id) === Number(sellingPlanId);
        }) || null;

        return Boolean(sourceAllocation);
      });

      if (!sourceAllocation) return null;

      return allocations.find(function (allocation) {
        if (sourceAllocation.selling_plan_group_id && allocation.selling_plan_group_id !== sourceAllocation.selling_plan_group_id) return false;
        return Number(allocation.position) === Number(sourceAllocation.position);
      }) || null;
    }

    function selectedSellingPlanAllocation(variant, mode, sellingPlanId) {
      var allocations = variant && Array.isArray(variant.selling_plan_allocations)
        ? variant.selling_plan_allocations
        : [];
      var selectedMode = mode || state.purchase.mode;
      var selectedPlanId = sellingPlanId !== undefined ? sellingPlanId : state.purchase.sellingPlanId;

      if (selectedMode !== 'subscription') return null;
      if (variant && variant.is_special_product) {
        return matchingSpecialSellingPlanAllocation(variant, selectedPlanId);
      }
      if (selectedPlanId) {
        var matchingAllocation = allocations.find(function (allocation) {
          return Number(allocation.selling_plan_id) === Number(selectedPlanId);
        });

        if (matchingAllocation) return matchingAllocation;

        return bestSellingPlanAllocation(variant);
      }

      return bestSellingPlanAllocation(variant);
    }

    function pricingForVariant(variant, mode, sellingPlanId) {
      var allocation = selectedSellingPlanAllocation(variant, mode, sellingPlanId);
      var effectivePrice = allocation ? Number(allocation.price || 0) : Number(variant && variant.price ? variant.price : 0);
      var oneTimePrice = Number(variant && variant.price ? variant.price : 0);
      var comparePrice = allocation && allocation.compare_at_price ? Number(allocation.compare_at_price) : Number(variant && variant.compare_at_price ? variant.compare_at_price : 0);
      var packUnits = Number(variant && variant.pack_units ? variant.pack_units : 1);
      var savings;
      var discountPercent = null;

      if (!comparePrice || comparePrice < effectivePrice) comparePrice = variant && variant.compare_at_price && variant.compare_at_price > effectivePrice
        ? Number(variant.compare_at_price)
        : oneTimePrice;

      savings = Math.max(0, comparePrice - effectivePrice);
      if (savings > 0 && comparePrice > 0) discountPercent = Math.round((savings / comparePrice) * 100);

      return {
        oneTimePrice: oneTimePrice,
        effectivePrice: effectivePrice,
        comparePrice: Math.max(comparePrice, effectivePrice),
        unitPrice: packUnits > 0 ? Math.round(effectivePrice / packUnits) : effectivePrice,
        packUnits: packUnits,
        savings: savings,
        discountPercent: discountPercent,
        sellingPlanId: allocation ? allocation.selling_plan_id : null,
        sellingPlanName: allocation ? allocation.selling_plan_name : ''
      };
    }

    function sharedDiscountPercent(items) {
      var uniquePercents = [];
      var eligibleItems = Array.isArray(items) ? items : [];

      if (!eligibleItems.length) return null;

      for (var index = 0; index < eligibleItems.length; index += 1) {
        var percent = Number(eligibleItems[index].discount_percent);
        if (!percent || !Number.isFinite(percent)) return null;
        if (uniquePercents.indexOf(percent) === -1) uniquePercents.push(percent);
        if (uniquePercents.length > 1) return null;
      }

      return uniquePercents[0] || null;
    }

    function selectedSubscriptionDiscountPercent() {
      if (state.purchase.mode !== 'subscription') return null;
      if (state.selectedItems.length) return sharedDiscountPercent(state.selectedItems);

      return sharedDiscountPercent(variantsForSelectedPack().map(function (variant) {
        return {
          discount_percent: pricingForVariant(variant, 'subscription').discountPercent
        };
      }));
    }

    function updateSubscriptionSavingsCopy() {
      var discountPercent = selectedSubscriptionDiscountPercent();
      var ribbonDiscount = purchaseCopy('jciRibbonDiscountTemplate', 'Most Popular - Save [discount]% + Free Gift');
      var ribbonDefault = purchaseCopy('jciRibbonDefault', 'SUBSCRIBE & SAVE + FREE GIFT');
      var savingsDiscount = purchaseCopy('jciSavingsBenefitTemplate', 'Save [discount]% on every order');
      var savingsDefault = purchaseCopy('jciSavingsBenefitDefault', 'Subscription savings on every order');

      if (subscriptionRibbon) {
        subscriptionRibbon.textContent = discountPercent
          ? copyWithValue(ribbonDiscount, '[discount]', discountPercent)
          : ribbonDefault;
      }

      if (subscriptionBenefitSavings) {
        subscriptionBenefitSavings.textContent = discountPercent
          ? copyWithValue(savingsDiscount, '[discount]', discountPercent)
          : savingsDefault;
      }
    }

    function variantsForSelectedPack() {
      return variants.filter(function (variant) {
        return variant.available && variant.pack_size === state.selectedPack && isAllowedPackUnits(variant.pack_units);
      });
    }

    function fallbackUnitPrice(mode) {
      var packVariants = variantsForSelectedPack();
      var unitPrices = packVariants.map(function (variant) {
        return pricingForVariant(variant, mode).unitPrice;
      }).filter(function (unitPrice) {
        return unitPrice > 0;
      });

      if (!unitPrices.length) return 0;
      return Math.min.apply(Math, unitPrices);
    }

    function calculatePricing(selectedItems, boxQuantity, mode) {
      var oneTimeSubtotal = 0;
      var purchaseSubtotal = 0;
      var compareSubtotal = 0;
      var totalSticks = 0;
      var purchaseMode = mode || state.purchase.mode;

      selectedItems.forEach(function (item) {
        oneTimeSubtotal += item.price * item.quantity;
        purchaseSubtotal += item.purchase_price * item.quantity;
        compareSubtotal += item.compare_at_price * item.quantity;
        totalSticks += item.pack_units * item.quantity;
      });

      return {
        boxQuantity: boxQuantity,
        stickQuantity: totalSticks,
        oneTimeSubtotal: oneTimeSubtotal,
        purchaseSubtotal: purchaseSubtotal,
        compareSubtotal: compareSubtotal,
        savings: Math.max(0, compareSubtotal - purchaseSubtotal),
        unitPrice: totalSticks > 0 ? Math.round(purchaseSubtotal / totalSticks) : fallbackUnitPrice(purchaseMode),
        mode: purchaseMode,
        sellingPlanId: purchaseMode === 'subscription' ? state.purchase.sellingPlanId : null,
        giftVariantId: purchaseMode === 'subscription' ? state.purchase.giftVariantId : null
      };
    }

    function calculateModePricing(mode) {
      var selectedItems = [];
      var totalQuantity = 0;

      flavorCards.forEach(function (card) {
        var flavor = card.dataset.jciFlavor || '';
        var quantity = Number(state.quantitiesByFlavor[flavor] || 0);
        var variant = selectedVariantForCard(card);
        var variantPricing;

        if (!quantity || !variant || !variant.available) return;

        variantPricing = pricingForVariant(variant, mode);
        totalQuantity += quantity;
        selectedItems.push({
          price: variantPricing.oneTimePrice,
          purchase_price: variantPricing.effectivePrice,
          compare_at_price: variantPricing.comparePrice,
          discount_percent: variantPricing.discountPercent,
          pack_units: variantPricing.packUnits,
          quantity: quantity
        });
      });

      return calculatePricing(selectedItems, totalQuantity, mode);
    }

    function normalizedPackSize(value) {
      return String(value || '').trim().toLowerCase();
    }

    function defaultDisplayVariantForSelectedPack() {
      var selectedPack = normalizedPackSize(state.selectedPack);
      var fallbackVariant = null;

      flavorCards.some(function (card) {
        var variant = selectedVariantForCard(card);

        if (!variant || !variant.available) return false;
        if (normalizedPackSize(variant.pack_size || card.dataset.jciFixedPackSize) !== selectedPack) return false;
        if (card.dataset.jciSpecialProduct === 'true' || variant.is_special_product) {
          if (!fallbackVariant) fallbackVariant = variant;
          return false;
        }

        fallbackVariant = variant;
        return true;
      });

      return fallbackVariant;
    }

    function defaultDisplayPricing(mode) {
      var variant = defaultDisplayVariantForSelectedPack();
      var variantPricing;

      if (!variant) return calculatePricing([], 0, mode);

      variantPricing = pricingForVariant(variant, mode);

      return calculatePricing([{
        price: variantPricing.oneTimePrice,
        purchase_price: variantPricing.effectivePrice,
        compare_at_price: variantPricing.comparePrice,
        discount_percent: variantPricing.discountPercent,
        pack_units: variantPricing.packUnits,
        quantity: 1
      }], 1, mode);
    }

    function updateUnitPill(pricing) {
      var prefix;
      var suffix;
      var text = [];

      if (!unitPill || !pricing.unitPrice) return;

      prefix = unitPill.dataset.jciUnitPrefix || '';
      suffix = unitPill.dataset.jciUnitSuffix || '';

      if (prefix) text.push(prefix);
      text.push(formatMoney(pricing.unitPrice, moneyFormat));
      if (suffix) text.push(suffix);

      unitPill.textContent = text.join(' ');
    }

    function updatePricingDom(pricing) {
      if (totalItems) totalItems.textContent = pricing.boxQuantity + ' box' + (pricing.boxQuantity === 1 ? '' : 'es');
      if (totalLabel) totalLabel.textContent = state.purchase.mode === 'subscription' ? 'Subscription total' : 'One-time total';
      if (savingsLabel) savingsLabel.textContent = state.purchase.mode === 'subscription' ? 'Subscription savings' : 'Sale savings';
      if (oneTimeTotal) oneTimeTotal.textContent = formatMoney(pricing.purchaseSubtotal, moneyFormat);
      if (totalSavings) totalSavings.textContent = formatMoney(pricing.savings, moneyFormat);
      if (summaryUnitPrice) summaryUnitPrice.textContent = pricing.unitPrice ? formatMoney(pricing.unitPrice, moneyFormat) + '/stick' : '-';
      setHidden(savingsRow, pricing.savings <= 0);
      updateUnitPill(pricing);
    }

    function setCartMessage(message, isError) {
      if (!cartMessage) return;
      cartMessage.textContent = message || '';
      cartMessage.classList.toggle('is-error', Boolean(isError));
    }

    function updatePurchaseOptions() {
      var canSubscribe = Boolean(skioPlans.length);

      if (!canSubscribe && state.purchase.mode === 'subscription') state.purchase.mode = 'one_time';

      purchaseButtons.forEach(function (button) {
        var mode = button.dataset.jciPurchaseMode;
        var isActive = mode === state.purchase.mode;

        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
        if (mode === 'subscription') button.disabled = !canSubscribe;
      });

      if (deliveryControl) deliveryControl.hidden = state.purchase.mode !== 'subscription' || !canSubscribe;
      if (giftPanel) giftPanel.hidden = state.purchase.mode !== 'subscription';
    }

    function updatePlanReadouts(pricing) {
      var subscriptionTotal = root.querySelector('[data-jci-subscription-total]');
      var subscriptionCompare = root.querySelector('[data-jci-subscription-compare]');
      var subscriptionUnit = root.querySelector('[data-jci-subscription-unit]');
      var subscriptionStickTotal = root.querySelector('[data-jci-subscription-stick-total]');
      var oneTimeOptionTotal = root.querySelector('[data-jci-one-time-option-total]');
      var oneTimeUnit = root.querySelector('[data-jci-one-time-unit]');
      var hasSelection = state.totalQuantity > 0;
      var subscriptionPricing = hasSelection ? calculateModePricing('subscription') : defaultDisplayPricing('subscription');
      var oneTimePricing = hasSelection ? calculateModePricing('one_time') : defaultDisplayPricing('one_time');
      var oneTimeUnitValue = oneTimePricing.unitPrice || fallbackUnitPrice('one_time');

      if (subscriptionTotal) subscriptionTotal.textContent = formatMoney(subscriptionPricing.purchaseSubtotal, moneyFormat);
      if (subscriptionCompare) {
        subscriptionCompare.textContent = formatMoney(subscriptionPricing.compareSubtotal, moneyFormat);
        subscriptionCompare.hidden = subscriptionPricing.compareSubtotal <= subscriptionPricing.purchaseSubtotal;
      }
      if (subscriptionUnit) subscriptionUnit.textContent = subscriptionPricing.unitPrice ? formatMoney(subscriptionPricing.unitPrice, moneyFormat) + ' per stick' : '';
      if (subscriptionStickTotal) {
        subscriptionStickTotal.textContent = subscriptionPricing.stickQuantity + ' stick' + (subscriptionPricing.stickQuantity === 1 ? '' : 's');
        subscriptionStickTotal.hidden = subscriptionPricing.stickQuantity <= 0;
      }
      if (oneTimeOptionTotal) oneTimeOptionTotal.textContent = formatMoney(oneTimePricing.oneTimeSubtotal, moneyFormat);
      if (oneTimeUnit) oneTimeUnit.textContent = oneTimeUnitValue ? formatMoney(oneTimeUnitValue, moneyFormat) + ' per stick' : '';
    }

    function updateGiftOptions() {
      giftOptions.forEach(function (option) {
        var isActive = Number(option.dataset.jciGiftVariantId || 0) === Number(state.purchase.giftVariantId || 0);

        option.classList.toggle('is-active', isActive);
        option.setAttribute('aria-pressed', String(isActive));
      });
    }

    function closePlanDropdown() {
      if (!planDropdown) return;

      planDropdown.classList.remove('is-open');
      if (planDropdownToggle) planDropdownToggle.setAttribute('aria-expanded', 'false');
      if (planDropdownMenu) planDropdownMenu.hidden = true;
    }

    function togglePlanDropdown() {
      if (!planDropdown || !planDropdownMenu) return;

      var isOpen = planDropdown.classList.contains('is-open');
      planDropdown.classList.toggle('is-open', !isOpen);
      planDropdownMenu.hidden = isOpen;
      if (planDropdownToggle) planDropdownToggle.setAttribute('aria-expanded', String(!isOpen));
    }

    function syncPlanDropdown() {
      if (!sellingPlanSelect || !planDropdownOptions.length) return;

      planDropdownOptions.forEach(function (option) {
        var isActive = String(option.dataset.jciPlanId || '') === String(sellingPlanSelect.value || '');
        option.classList.toggle('is-active', isActive);
        option.setAttribute('aria-selected', String(isActive));

        if (isActive && planDropdownCurrent) {
          planDropdownCurrent.textContent = option.textContent.trim();
        }
      });
    }

    function selectedCardForItem(item) {
      return flavorCards.find(function (card) {
        return card.dataset.jciFlavor === item.flavor;
      }) || null;
    }

    function updateSelectedSummary() {
      if (!selectedSummary || !selectedSummaryItems) return;

      selectedSummary.hidden = state.selectedItems.length === 0;
      selectedSummaryItems.innerHTML = '';

      state.selectedItems.forEach(function (item) {
        var card = selectedCardForItem(item);
        var image = card ? card.querySelector('.jci-pdp__flavor-image img') : null;
        var summaryItem = document.createElement('div');
        var imageBox = document.createElement('div');
        var label = document.createElement('span');

        summaryItem.className = 'jci-pdp__selected-summary-item';
        imageBox.className = 'jci-pdp__selected-summary-image';
        label.className = 'jci-pdp__selected-summary-label';
        label.textContent = item.flavor + ' (' + item.pack_size + ')' + (item.quantity > 1 ? ' x' + item.quantity : '');

        if (image) {
          imageBox.appendChild(image.cloneNode(false));
        }

        summaryItem.appendChild(imageBox);
        summaryItem.appendChild(label);
        selectedSummaryItems.appendChild(summaryItem);
      });
    }

    function updateAddButton() {
      if (!addButton) return;

      if (state.isAdding) {
        addButton.disabled = true;
        addButton.textContent = addButton.dataset.jciAddingLabel || 'Adding...';
        return;
      }

      var disabledReason = '';
      if (!state.totalQuantity) disabledReason = addButton.dataset.jciEmptyLabel || 'Select your flavors';
      if (state.purchase.mode === 'subscription' && (!skioPlans.length || !state.purchase.sellingPlanId)) {
        disabledReason = addButton.dataset.jciUnavailableLabel || 'Subscription unavailable';
      }

      addButton.disabled = Boolean(disabledReason);
      if (disabledReason) {
        addButton.textContent = disabledReason;
        return;
      }

      var label = document.createElement('span');
      var price = document.createElement('span');
      var arrow = document.createElement('span');

      label.textContent = addButton.dataset.jciAddLabel || 'Add to Cart';
      price.className = 'jci-pdp__add-button-price';
      price.textContent = formatMoney(state.pricing.purchaseSubtotal, moneyFormat);
      arrow.className = 'jci-pdp__add-button-arrow';
      arrow.setAttribute('aria-hidden', 'true');
      price.appendChild(arrow);

      addButton.replaceChildren(label, price);
    }

    function updatePurchaseDom() {
      updatePurchaseOptions();
      syncPlanDropdown();
      updatePlanReadouts(state.pricing);
      updateSubscriptionSavingsCopy();
      updateGiftOptions();
      updateSelectedSummary();
      updateAddButton();
    }

    function buildOneTimeItems() {
      return state.selectedItems.map(function (item) {
        return {
          id: Number(item.variant_id),
          quantity: Number(item.quantity)
        };
      });
    }

    function buildSubscriptionItems() {
      var normalItems = state.selectedItems.filter(function (item) {
        return !item.is_special_product;
      });
      var specialItems = state.selectedItems.filter(function (item) {
        return item.is_special_product;
      });
      var items = [];

      if (normalItems.length) {
        if (!state.purchase.sellingPlanId) {
          throw new Error(addButton && addButton.dataset.jciNoPlanError
            ? addButton.dataset.jciNoPlanError
            : 'No subscription delivery frequency selected.');
        }

        normalItems.forEach(function (item) {
          var sellingPlanId = item.selected_selling_plan_id || state.purchase.sellingPlanId;

          if (!sellingPlanId) throw new Error(subscriptionUnavailableFor(item.flavor));

          items.push({
            id: Number(item.variant_id),
            quantity: Number(item.quantity),
            selling_plan: Number(sellingPlanId)
          });
        });

      }

      specialItems.forEach(function (item) {
        var specialVariant = variants.find(function (variant) {
          return String(variant.id) === String(item.variant_id);
        });
        var specialAllocation = matchingSpecialSellingPlanAllocation(specialVariant, state.purchase.sellingPlanId);
        var sellingPlanId = item.selected_selling_plan_id || (specialAllocation && specialAllocation.selling_plan_id);
        var cartItem = {
          id: Number(item.variant_id),
          quantity: Number(item.quantity)
        };

        if (sellingPlanId) {
          cartItem.selling_plan = Number(sellingPlanId);
        } else if (!normalItems.length) {
          if (!item.selected_selling_plan_id) throw new Error(subscriptionUnavailableFor(item.flavor));
        }

        items.push(cartItem);
      });

      return items;
    }

    function subscriptionUnavailableFor(flavor) {
      var template = addButton && addButton.dataset.jciUnavailableFlavorTemplate
        ? addButton.dataset.jciUnavailableFlavorTemplate
        : 'Subscription unavailable for [flavor].';

      return copyWithValue(template, '[flavor]', flavor || '');
    }

    function buildCartItems(mode) {
      return (mode || state.purchase.mode) === 'subscription' ? buildSubscriptionItems() : buildOneTimeItems();
    }

    function getNativeCartSurface() {
      return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    }

    function getCartAddUrl() {
      return (cartRoutes && cartRoutes.cart_add_url) || (window.routes && window.routes.cart_add_url) || '/cart/add.js';
    }

    function getCartUrl() {
      return (cartRoutes && cartRoutes.cart_url) || (window.routes && window.routes.cart_url) || '/cart';
    }

    function getCheckoutUrl() {
      return (cartRoutes && cartRoutes.checkout_url) || '/checkout';
    }

    async function refreshNativeCartSurface(shouldOpen) {
      var surface = getNativeCartSurface();
      var sectionsToRender;
      var sectionIds;
      var response;
      var sections;

      if (!surface || typeof surface.getSectionsToRender !== 'function') return false;
      if (shouldOpen && surface.tagName && surface.tagName.toLowerCase() === 'cart-notification') return false;

      sectionsToRender = surface.getSectionsToRender();
      sectionIds = sectionsToRender.map(function (section) {
        return section.section || section.id;
      }).filter(Boolean);

      if (!sectionIds.length) return false;

      response = await fetch(window.location.pathname + '?sections=' + encodeURIComponent(sectionIds.join(',')), {
        method: 'GET',
        headers: { 'Accept': 'application/json' },
        credentials: 'same-origin',
        cache: 'no-store'
      });

      if (!response.ok) return false;

      sections = await response.json();
      sectionsToRender.forEach(function (section) {
        var sectionId = section.section || section.id;
        var html = sections[sectionId];
        var target = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
        var source;

        if (!html || !target) return;

        source = new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector(section.selector || '.shopify-section');

        if (source) target.innerHTML = source.innerHTML;
      });

      if (surface.classList) surface.classList.remove('is-empty');
      if (shouldOpen && typeof surface.open === 'function') surface.open();

      return true;
    }

    function normalizeShopifyNumericId(value) {
      var match;

      if (value === null || value === undefined) return '';

      match = String(value).match(/(\d+)$/);

      return match ? match[1] : String(value);
    }

    async function readGiftCart() {
      var response = await fetch(getCartUrl() + '.js', {
        headers: { 'Accept': 'application/json' },
        credentials: 'same-origin',
        cache: 'no-store'
      });
      if (!response.ok) throw new Error('Unable to check your free gift. Please try again.');
      return response.json();
    }

    // Use the real reward rule, not the shipping tier or the first configured rule.
    // A collection in the picker does not itself grant a Shopify discount.
    async function prepareWelcomeGift(items, variantId) {
      var token = window.upcartStorefrontPublicAccessToken;
      var editor = window.upcartSettings && window.upcartSettings.upcartEditorSettings;
      var publicRules = editor && editor.rewardsTriggeredRules;
      var giftId = normalizeShopifyNumericId(variantId);
      // Published FREEWELCOMEGIFT rule for the selected PDP welcome gift.
      var isolatedRuleId = 'afa3775f-ee59-468f-b2b1-1e4ebf50646f';
      var giftMarker = '_jci_welcome_gift_165077025004';
      var unavailable = 'This gift is not currently available for free. Please choose another gift.';
      if (!token || !publicRules || !items.some(function (item) { return item.selling_plan; })) {
        throw new Error('Unable to confirm your free gift. Please try again.');
      }

      var results = await Promise.all([
        readGiftCart(),
        fetch('/api/2025-07/graphql.json', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': token },
          body: JSON.stringify({ query: 'query { shop { metafield(namespace: "$app:discount", key: "rules") { value } } }' })
        }).then(function (response) {
          if (!response.ok) throw new Error('Unable to confirm your free gift. Please try again.');
          return response.json();
        })
      ]);
      var cart = results[0];
      var payload = results[1];
      var metafield = payload.data && payload.data.shop && payload.data.shop.metafield;
      if (payload.errors || !metafield) throw new Error('Unable to confirm your free gift. Please try again.');
      var rules = JSON.parse(metafield.value);
      items.forEach(function (item) {
        if (item.selling_plan) {
          item.properties = Object.assign({}, item.properties, { '_jci_welcome_gift_flow': '165077025004', '_jci_welcome_gift_165077025004': 'true' });
        }
      });
      var prospectiveItems = cart.items.concat(items.map(function (item) {
        return { variant_id: item.id, quantity: item.quantity, properties: item.properties, selling_plan_allocation: item.selling_plan ? {} : null };
      }));
      var prospectiveGift = { variant_id: Number(giftId), quantity: 1, properties: {} };
      prospectiveGift.properties[giftMarker] = 'true';
      prospectiveItems.push(prospectiveGift);
      var rule = rules.find(function (candidate) {
        if (candidate.id !== isolatedRuleId || !candidate.enabled || !publicRules.some(function (configured) {
          return configured.discountId === candidate.id;
        })) return false;
        var supportsGift = (candidate.operations || []).some(function (operation) {
          return operation.type === 'free_gift' && Object.keys(operation.productIds || {}).some(function (id) {
            return operation.productIds[id].some(function (id) { return normalizeShopifyNumericId(id) === giftId; });
          });
        });
        var requiresSubscription = (candidate.conditions || []).some(function (condition) {
          return condition.type === 'product_with_subscription_exists';
        });
        if (!supportsGift || !requiresSubscription) return false;
        return candidate.conditions.every(function (condition) {
          var quantity = 0;
          if (condition.type === 'product_with_subscription_exists') {
            prospectiveItems.forEach(function (item) {
              if (item.selling_plan_allocation) quantity += item.quantity;
            });
          } else if (condition.type === 'product_with_id_exists') {
            var ids = [];
            Object.keys(condition.productIds || {}).forEach(function (id) {
              ids = ids.concat(condition.productIds[id].map(normalizeShopifyNumericId));
            });
            prospectiveItems.forEach(function (item) {
              if (ids.indexOf(String(item.variant_id)) !== -1) quantity += item.quantity;
            });
          } else if (condition.type === 'product_with_line_item_property_key_exists') {
            prospectiveItems.forEach(function (item) {
              if ((condition.properties || []).some(function (key) {
                return Object.prototype.hasOwnProperty.call(item.properties || {}, key);
              })) quantity += item.quantity;
            });
          } else {
            // Unknown eligibility conditions must not turn a paid item into a promised gift.
            return false;
          }
          return quantity >= condition.numMatches;
        });
      });
      if (!rule) throw new Error(unavailable);
      var existing = cart.items.filter(function (item) {
        var properties = item.properties || {};
        return properties.__upcartFreeGift === 'true' && properties.__upcartTriggeredReward === rule.id;
      });
      var selected = existing.find(function (item) { return String(item.variant_id) === giftId; });
      if (!selected) {
        items.push({ id: Number(giftId), quantity: 1, properties: {
          '__upcartRewardProduct': giftId,
          '__upcartTriggeredReward': rule.id,
          '__upcartFreeGift': 'true',
          '_jci_welcome_gift_165077025004': 'true'
        } });
      }
      return { variantId: giftId, ruleId: rule.id, hadSelectedGift: Boolean(selected) };
    }

    async function finishWelcomeGift(gift) {
      var cart = await readGiftCart();
      var rewardItems = cart.items.filter(function (item) {
        var properties = item.properties || {};
        return properties.__upcartFreeGift === 'true' && (
          properties.__upcartTriggeredReward === gift.ruleId ||
          properties.__upcartTriggeredReward === '8fdd07cd-7653-4683-a78a-d44899392fae' ||
          properties.__upcartTriggeredReward === 'b69dbf10-9b0c-4577-8f78-6b06243d7aed'
        );
      });
      var selected = rewardItems.find(function (item) {
        return String(item.variant_id) === gift.variantId && item.properties.__upcartTriggeredReward === gift.ruleId;
      });
      var updates = {};
      if (!selected) throw new Error('Your subscription was added, but the free gift could not be confirmed. Please review your cart before checkout.');
      // Swap the marked reward first. While both choices are in the cart,
      // Shopify can assign the single gift discount to the previous choice.
      // The newly selected gift is already present, so UpCart never sees an
      // intermediate cart with no reward and cannot insert a default shaker.
      rewardItems.forEach(function (item) {
        if (item.key !== selected.key) updates[item.key] = 0;
        else if (item.quantity !== 1) updates[item.key] = 1;
      });
      if (Object.keys(updates).length) {
        cart = await updateGiftLines(updates);
        selected = cart.items.find(function (item) {
          return String(item.variant_id) === gift.variantId &&
            item.properties.__upcartTriggeredReward === gift.ruleId;
        });
      }
      // Shopify remains the source of truth for price, including at checkout.
      if (!selected || selected.line_price !== 0) {
        var stillQualifies = cart.items.some(function (item) {
          return item.selling_plan_allocation && item.properties._jci_welcome_gift_165077025004 === 'true';
        });
        // If eligibility disappeared, UpCart already owns reward removal.
        // Do not race it with another removal request.
        if (selected && !gift.hadSelectedGift && stillQualifies) {
          var removal = {};
          removal[selected.key] = 0;
          await updateGiftLines(removal);
        }
        throw new Error('Your subscription was added, but the free gift could not be confirmed. Please review your cart before checkout.');
      }
    }

    async function updateGiftLines(updates) {
      var response = await fetch(getCartUrl() + '/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates })
      });
      if (!response.ok) throw new Error('Unable to update your free gift. Please review your cart.');
      return response.json();
    }

    async function openUpCartDrawer() {
      var hasUpCart = document.getElementById('upCart') || window.upcart || typeof window.upcartOpenCart === 'function';

      if (!hasUpCart) return false;

      try {
        if (typeof window.upcartRefreshCart === 'function') {
          await Promise.resolve(window.upcartRefreshCart());
        }
        if (typeof window.upcartOpenCart === 'function') {
          window.upcartOpenCart();
          return true;
        }
        if (window.upcart && typeof window.upcart.open === 'function') {
          window.upcart.open();
          return true;
        }
      } catch (error) {
        return false;
      }

      return false;
    }

    async function addToCart(modeOverride) {
      var items;
      var purchaseMode = modeOverride || state.purchase.mode;
      var cartSurface = getNativeCartSurface();
      var body;
      var response;
      var json;
      var upCartOpened;
      var gift;
      var giftVariantId = purchaseMode === 'subscription' ? state.purchase.giftVariantId : null;

      if (!state.totalQuantity || state.isAdding) return;

      try {
        items = buildCartItems(purchaseMode);
      } catch (error) {
        setCartMessage(error.message, true);
        return;
      }

      if (!items.length) return;

      setCartMessage('', false);
      state.isAdding = true;
      updateAddButton();

      try {
        if (giftVariantId) gift = await prepareWelcomeGift(items, giftVariantId);
      } catch (error) {
        state.isAdding = false;
        setCartMessage(error.message, true);
        updateAddButton();
        return;
      }

      body = { items: items };
      if (cartSurface && typeof cartSurface.getSectionsToRender === 'function') {
        body.sections = cartSurface.getSectionsToRender().map(function (section) {
          return section.id;
        });
        body.sections_url = window.location.pathname;
        if (typeof cartSurface.setActiveElement === 'function') cartSurface.setActiveElement(document.activeElement);
      }

      try {
        response = await fetch(getCartAddUrl(), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(body)
        });
        json = await response.json().catch(function () {
          return {};
        });

        if (!response.ok || json.status) {
          throw new Error(json.description || json.message || 'Add to cart failed.');
        }

        if (gift) await finishWelcomeGift(gift);

        root.dispatchEvent(new CustomEvent('jci:pdp-cart-add', {
          bubbles: true,
          detail: {
            mode: purchaseMode,
            items: items,
            response: json
          }
        }));

        await refreshCartCount();

        upCartOpened = await openUpCartDrawer();
        if (upCartOpened) {
          updateAddButton();
          return;
        }

        if (purchaseMode === 'subscription') {
          if (await refreshNativeCartSurface(true)) {
            updateAddButton();
            return;
          }

          window.location.href = purchaseRoot && purchaseRoot.dataset.jciAfterSubscriptionAdd
            ? purchaseRoot.dataset.jciAfterSubscriptionAdd
            : getCheckoutUrl();
          return;
        }

        if (cartSurface && json.sections && typeof cartSurface.renderContents === 'function') {
          cartSurface.renderContents(json);
          updateAddButton();
          return;
        }

        window.location.href = getCartUrl();
      } catch (error) {
        setCartMessage(error.message, true);
      } finally {
        state.isAdding = false;
        updateAddButton();
      }
    }

    function updateBadges(card, variant, isAvailable) {
      var badges = card.querySelector('[data-jci-flavor-badges]');
      var saleBadge = card.querySelector('[data-jci-sale-badge]');
      var soldOutBadge = card.querySelector('[data-jci-sold-out-badge]');
      var soldOutControl = card.querySelector('[data-jci-sold-out-control]');
      var onSale = Boolean(variant && variant.compare_at_price && variant.compare_at_price > variant.price);
      var hasManualBadges = Boolean(
        badges && badges.querySelector('[data-jci-manual-badge], [data-jci-featured-badge]')
      );

      card.classList.toggle('is-sale', onSale);
      setHidden(saleBadge, !onSale);
      setHidden(soldOutBadge, isAvailable);
      setHidden(soldOutControl, isAvailable);
      setHidden(badges, !hasManualBadges && !onSale && !(soldOutBadge && !isAvailable));
    }

    function updatePrice(card, variant) {
      var price = card.querySelector('[data-jci-flavor-price]');
      var actions;
      if (!price || !variant) return;

      actions = Array.prototype.slice.call(price.querySelectorAll('[data-jci-modal-open]'));
      price.textContent = '';

      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        var salePrice = document.createElement('span');
        var comparePrice = document.createElement('s');

        salePrice.className = 'jci-pdp__sale-price';
        salePrice.textContent = formatMoney(variant.price, moneyFormat) + '/box';
        comparePrice.textContent = formatMoney(variant.compare_at_price, moneyFormat) + '/box';
        price.appendChild(salePrice);
        price.appendChild(document.createTextNode(' '));
        price.appendChild(comparePrice);
        actions.forEach(function (action) {
          price.appendChild(document.createTextNode(' '));
          price.appendChild(action);
        });
        return;
      }

      price.appendChild(document.createTextNode(formatMoney(variant.price, moneyFormat) + '/box'));
      actions.forEach(function (action) {
        price.appendChild(document.createTextNode(' '));
        price.appendChild(action);
      });
    }

    function updateFlavorImage(card, variant) {
      var image = card.querySelector('.jci-pdp__flavor-pack img') || card.querySelector('.jci-pdp__flavor-image > img');

      if (card.dataset.jciSelectorCardImage === 'true') return;
      if (!image || !variant || !variant.featured_media_image) return;

      image.src = variant.featured_media_image;
      if (variant.featured_media_srcset) image.srcset = variant.featured_media_srcset;
      if (variant.featured_media_alt) image.alt = variant.featured_media_alt;
    }

    function updatePackCardImage(card, variant) {
      var image = card.querySelector('.jci-pdp__placeholder-image img');

      if (!card || !variant || !image || !variant.featured_media_image) return;

      card.dataset.jciVariantId = String(variant.id);
      if (variant.featured_media_id) card.dataset.jciMediaId = String(variant.featured_media_id);

      image.src = variant.featured_media_image;
      if (variant.featured_media_srcset) image.srcset = variant.featured_media_srcset;
      if (variant.featured_media_alt) image.alt = variant.featured_media_alt;
    }

    function updateSelectionModel() {
      var selectedItems = [];
      var totalQuantity = 0;

      flavorCards.forEach(function (card) {
        var flavor = card.dataset.jciFlavor || '';
        var quantity = Number(state.quantitiesByFlavor[flavor] || 0);
        var variant = selectedVariantForCard(card);
        var packSize;
        var variantPricing;

        if (!quantity || !variant || !variant.available) return;

        packSize = variant.pack_size || card.dataset.jciFixedPackSize || state.selectedPack;
        variantPricing = pricingForVariant(variant);
        totalQuantity += quantity;
        selectedItems.push({
          flavor: flavor,
          pack_size: packSize,
          quantity: quantity,
          variant_id: variant.id,
          sku: variant.sku || '',
          media_id: variant.featured_media_id || null,
          price: variantPricing.oneTimePrice,
          compare_at_price: variantPricing.comparePrice,
          best_selling_plan_id: variantPricing.sellingPlanId,
          best_selling_plan_name: variantPricing.sellingPlanName,
          best_selling_plan_price: variantPricing.effectivePrice,
          best_unit_price: variantPricing.unitPrice,
          best_savings: variantPricing.savings,
          best_discount_percent: variantPricing.discountPercent,
          purchase_mode: state.purchase.mode,
          purchase_price: variantPricing.effectivePrice,
          selected_selling_plan_id: state.purchase.mode === 'subscription' ? variantPricing.sellingPlanId : null,
          selected_selling_plan_name: state.purchase.mode === 'subscription' ? variantPricing.sellingPlanName : '',
          selected_unit_price: variantPricing.unitPrice,
          selected_savings: variantPricing.savings,
          discount_percent: variantPricing.discountPercent,
          pack_units: variantPricing.packUnits,
          is_special_product: Boolean(variant.is_special_product)
        });
      });

      state.selectedItems = selectedItems;
      state.totalQuantity = totalQuantity;
      state.pricing = calculatePricing(selectedItems, totalQuantity, state.purchase.mode);
      root.dataset.jciSelectedTotal = String(totalQuantity);
      root.classList.toggle('is-empty', totalQuantity === 0);
      updatePricingDom(state.pricing);
      updatePurchaseDom();

      if (status) {
        status.textContent = totalQuantity === 0
          ? 'No flavors selected'
          : totalQuantity + ' flavor item' + (totalQuantity === 1 ? '' : 's') + ' selected';
      }

      root.dispatchEvent(new CustomEvent('jci:pdp-selection-change', {
        bubbles: true,
        detail: {
          selectedPack: state.selectedPack,
          selectedItems: selectedItems.slice(),
          totalQuantity: totalQuantity,
          pricing: Object.assign({}, state.pricing),
          purchase: Object.assign({}, state.purchase),
          lastAdded: state.lastAdded
        }
      }));
    }

    function updateFlavorCard(card) {
      var flavor = card.dataset.jciFlavor || '';
      var variant = selectedVariantForCard(card);
      var isAvailable = Boolean(variant && variant.available);
      var quantity = isAvailable ? Number(state.quantitiesByFlavor[flavor] || 0) : 0;
      var decrease = card.querySelector('[data-jci-quantity-decrease]');
      var increase = card.querySelector('[data-jci-quantity-increase]');
      var value = card.querySelector('[data-jci-quantity-value]');

      if (!isAvailable) state.quantitiesByFlavor[flavor] = 0;

      card.dataset.jciQuantity = String(quantity);
      card.dataset.jciAvailable = String(isAvailable);
      card.dataset.jciVariantId = variant ? String(variant.id) : '';
      card.dataset.jciMediaId = variant && variant.featured_media_id ? String(variant.featured_media_id) : card.dataset.jciMediaId || '';
      card.classList.toggle('is-selected', quantity > 0);
      card.classList.toggle('is-unavailable', !isAvailable);

      if (value) value.textContent = String(quantity);
      if (decrease) decrease.disabled = !isAvailable || quantity <= 0;
      if (increase) increase.disabled = !isAvailable;

      updateBadges(card, variant, isAvailable);
      updatePrice(card, variant);
      updateFlavorImage(card, variant);
    }

    function updatePackCards() {
      packCards.forEach(function (card) {
        var isActive = card.dataset.jciPackSize === state.selectedPack;
        var activePackVariant = state.activeFlavor
          ? variantFor(state.activeFlavor, card.dataset.jciPackSize)
          : null;

        if (activePackVariant) updatePackCardImage(card, activePackVariant);

        card.classList.toggle('is-active', isActive);
        card.setAttribute('aria-pressed', String(isActive));
        card.disabled = !isAllowedPack(card);
      });
    }

    function render() {
      updatePackCards();
      flavorCards.forEach(updateFlavorCard);
      updateSelectionModel();
      syncVariantOption('Flavor', state.activeFlavor);
    }

    function initializeGalleryFromLastFlavor() {
      if (!gallery || gallery.dataset.jciInitialFlavorMediaApplied === 'true') return;

      if (initialUrlVariant) {
        gallery.dataset.jciInitialFlavorMediaApplied = 'true';
        syncGalleryToVariant(initialUrlVariant);
        return;
      }

      var lastFlavorCard = flavorCards.slice().reverse().find(function (card) {
        return card.dataset.jciMediaId && card.dataset.jciFullSrc;
      });
      var lastFlavorVariant = lastFlavorCard ? selectedVariantForCard(lastFlavorCard) : null;

      if (!lastFlavorCard || !lastFlavorVariant) return;

      gallery.dataset.jciInitialFlavorMediaApplied = 'true';
      state.activeFlavor = lastFlavorVariant.flavor || lastFlavorCard.dataset.jciFlavor || '';
      updatePackCards();
      syncVariantOption('Flavor', state.activeFlavor);
      syncGalleryToVariant(lastFlavorVariant);
    }

    function changeQuantity(card, delta) {
      var flavor = card.dataset.jciFlavor || '';
      var variant = selectedVariantForCard(card);
      var isAvailable = Boolean(variant && variant.available);
      var currentQuantity = Number(state.quantitiesByFlavor[flavor] || 0);
      var nextQuantity = Math.max(0, currentQuantity + delta);

      if (!isAvailable) return;

      state.quantitiesByFlavor[flavor] = nextQuantity;
      state.activeFlavor = flavor;

      if (delta > 0) {
        state.lastAdded = {
          flavor: flavor,
          pack_size: variant.pack_size || card.dataset.jciFixedPackSize || state.selectedPack,
          variant_id: variant.id,
          sku: variant.sku || '',
          media_id: variant.featured_media_id || null
        };

        if (gallery) {
          gallery.dispatchEvent(new CustomEvent('jci:pdp-last-added-variant', {
            bubbles: true,
            detail: galleryPayloadForVariant(variant, card)
          }));
        }
        updateUrlForVariant(variant);
      }

      render();
    }

    packCards.forEach(function (card) {
      card.addEventListener('click', function () {
        if (card.disabled || !isAllowedPack(card)) return;
        state.selectedPack = card.dataset.jciPackSize || state.selectedPack;
        render();
        if (state.activeFlavor) {
          var variant = variantFor(state.activeFlavor, state.selectedPack);
          if (variant) {
            updateUrlForVariant(variant);
            syncGalleryToVariant(variant);
          }
        }
      });
    });

    flavorCards.forEach(function (card) {
      var decrease = card.querySelector('[data-jci-quantity-decrease]');
      var increase = card.querySelector('[data-jci-quantity-increase]');

      if (decrease) {
        decrease.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          changeQuantity(card, -1);
        });
      }

      if (increase) {
        increase.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          changeQuantity(card, 1);
        });
      }

      card.addEventListener('click', function (event) {
        if (event.target.closest('button, a, input, select, textarea')) return;
        setActiveFlavorUrlFromCard(card);
      });
    });

    document.addEventListener('jci:pdp-flavor-option-change', function (event) {
      var detail = event && event.detail ? event.detail : {};
      var card = cardForFlavor(detail.flavor);

      if (!card) return;
      setActiveFlavorUrlFromCard(card);
    });

    purchaseButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        if (button.disabled) return;
        // "Buy once" adds one-time items directly without changing the subscription selection.
        if (button.dataset.jciPurchaseMode === 'one_time') {
          addToCart('one_time');
          return;
        }
        state.purchase.mode = button.dataset.jciPurchaseMode || state.purchase.mode;
        render();
      });
    });

    if (sellingPlanSelect) {
      sellingPlanSelect.addEventListener('change', function () {
        state.purchase.sellingPlanId = sellingPlanSelect.value ? Number(sellingPlanSelect.value) : null;
        syncPlanDropdown();
        render();
      });
    }

    if (planDropdownToggle) {
      planDropdownToggle.addEventListener('click', function (event) {
        event.preventDefault();
        togglePlanDropdown();
      });
    }

    planDropdownOptions.forEach(function (option) {
      option.addEventListener('click', function (event) {
        event.preventDefault();
        if (!sellingPlanSelect) return;

        sellingPlanSelect.value = option.dataset.jciPlanId || '';
        state.purchase.sellingPlanId = sellingPlanSelect.value ? Number(sellingPlanSelect.value) : null;
        syncPlanDropdown();
        closePlanDropdown();
        render();
      });
    });

    document.addEventListener('click', function (event) {
      if (planDropdown && !event.target.closest('[data-jci-plan-dropdown]')) closePlanDropdown();
    });

    giftOptions.forEach(function (option) {
      option.addEventListener('click', function () {
        if (option.disabled) return;
        state.purchase.giftVariantId = option.dataset.jciGiftVariantId ? Number(option.dataset.jciGiftVariantId) : null;
        state.purchase.giftTitle = option.dataset.jciGiftTitle || '';
        render();
      });
    });

    if (addButton) {
      addButton.addEventListener('click', function () {
        addToCart();
      });
    }

    root.jciPdpState = {
      getState: function () {
        return {
          selectedPack: state.selectedPack,
          activeFlavor: state.activeFlavor,
          quantitiesByFlavor: Object.assign({}, state.quantitiesByFlavor),
          selectedItems: state.selectedItems.slice(),
          totalQuantity: state.totalQuantity,
          pricing: Object.assign({}, state.pricing),
          purchase: Object.assign({}, state.purchase),
          lastAdded: state.lastAdded ? Object.assign({}, state.lastAdded) : null
        };
      },
      buildCartItems: function () {
        return buildCartItems();
      }
    };

    render();
    initializeGalleryFromLastFlavor();
  }

  function initModal(modal) {
    if (!modal || modal.dataset.jciModalInitialized === 'true') return;

    var closeButtons = Array.prototype.slice.call(modal.querySelectorAll('[data-jci-modal-close]'));
    var overlay = modal.querySelector('[data-jci-modal-overlay]');
    var lastTrigger = null;
    var closeTimer = null;
    var hasPanelMotion = !modal.classList.contains('jci-pdp__variety-modal');

    modal.dataset.jciModalInitialized = 'true';

    function prefersReducedMotion() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function closeDropdown(dropdown) {
      if (!dropdown) return;

      var toggle = dropdown.querySelector('[data-jci-dropdown-toggle]');
      var menu = dropdown.querySelector('[data-jci-dropdown-menu]');

      dropdown.classList.remove('is-open');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      if (menu) menu.hidden = true;
    }

    function closeAllDropdowns(exceptDropdown) {
      modal.querySelectorAll('[data-jci-dropdown]').forEach(function (dropdown) {
        if (dropdown !== exceptDropdown) closeDropdown(dropdown);
      });
    }

    function openDropdown(dropdown) {
      if (!dropdown) return;

      var toggle = dropdown.querySelector('[data-jci-dropdown-toggle]');
      var menu = dropdown.querySelector('[data-jci-dropdown-menu]');

      closeAllDropdowns(dropdown);
      dropdown.classList.add('is-open');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      if (menu) menu.hidden = false;
    }

    function toggleDropdown(dropdown) {
      if (!dropdown) return;
      if (dropdown.classList.contains('is-open')) {
        closeDropdown(dropdown);
        return;
      }

      openDropdown(dropdown);
    }

    function setActivePanel(index, option) {
      var current = modal.querySelector('[data-jci-dropdown-current]');
      var pill = modal.querySelector('[data-jci-active-flavor-pill]');
      var color = option && option.dataset.jciFlavorColor ? option.dataset.jciFlavorColor : '#ffff91';
      var title = option && option.dataset.jciFlavorTitle ? option.dataset.jciFlavorTitle : '';

      modal.querySelectorAll('[data-jci-flavor-panel]').forEach(function (panel) {
        var isActive = panel.dataset.jciPanelIndex === String(index);
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
      });

      modal.querySelectorAll('[data-jci-dropdown-option]').forEach(function (item) {
        var isActive = item.dataset.jciPanelIndex === String(index);
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-selected', String(isActive));
      });

      if (current && title) {
        var currentSwatch = current.querySelector('.jci-pdp__modal-swatch');
        current.textContent = '';
        if (!currentSwatch) {
          currentSwatch = document.createElement('span');
          currentSwatch.className = 'jci-pdp__modal-swatch';
        }
        currentSwatch.style.backgroundColor = color;
        current.appendChild(currentSwatch);
        current.appendChild(document.createTextNode(title));
      }

      if (pill && title) {
        pill.textContent = title;
        pill.style.backgroundColor = color;
      }
    }

    function syncPanelToActiveFlavor(trigger) {
      var root = trigger && typeof trigger.closest === 'function' ? trigger.closest('.jci-pdp') : null;
      var state = root && root.jciPdpState && typeof root.jciPdpState.getState === 'function'
        ? root.jciPdpState.getState()
        : null;
      var flavor = state && (state.activeFlavor || (state.lastAdded && state.lastAdded.flavor));
      var option;

      if (!flavor && state && state.selectedItems && state.selectedItems.length) {
        flavor = state.selectedItems[0].flavor;
      }

      if (!flavor) return;

      option = Array.prototype.slice.call(modal.querySelectorAll('[data-jci-dropdown-option]')).find(function (item) {
        return handleize(item.dataset.jciFlavorTitle || item.textContent) === handleize(flavor);
      });

      if (option) setActivePanel(option.dataset.jciPanelIndex, option);
    }

    modal.querySelectorAll('.jci-pdp__ingredient-detail').forEach(function (detail) {
      detail.addEventListener('toggle', function () {
        var panel;

        if (!detail.open) return;

        panel = detail.closest('[data-jci-flavor-panel]') || modal;
        panel.querySelectorAll('.jci-pdp__ingredient-detail[open]').forEach(function (openDetail) {
          if (openDetail !== detail) openDetail.open = false;
        });
      });
    });

    function open(trigger) {
      lastTrigger = trigger || document.activeElement;
      window.clearTimeout(closeTimer);
      modal.hidden = false;
      document.body.style.setProperty('overflow', 'hidden', 'important');
      closeAllDropdowns();
      syncPanelToActiveFlavor(lastTrigger);

      if (hasPanelMotion) modal.offsetHeight;
      modal.classList.add('is-open');

      window.requestAnimationFrame(function () {
        var closeButton = modal.querySelector('[data-jci-modal-close]');
        if (closeButton) closeButton.focus({ preventScroll: true });
      });
    }

    function finishClose() {
      modal.hidden = true;
      document.body.style.overflow = '';
      closeAllDropdowns();

      if (lastTrigger && typeof lastTrigger.focus === 'function') {
        lastTrigger.focus({ preventScroll: true });
      }
    }

    function close() {
      modal.classList.remove('is-open');

      if (!hasPanelMotion || prefersReducedMotion()) {
        finishClose();
        return;
      }

      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(finishClose, 220);
    }

    closeButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        close();
      });
    });

    if (overlay) {
      overlay.addEventListener('click', function (event) {
        if (event.target === overlay) close();
      });
    }

    modal.addEventListener('click', function (event) {
      var toggle = event.target.closest('[data-jci-dropdown-toggle]');
      var option = event.target.closest('[data-jci-dropdown-option]');
      var dropdown = event.target.closest('[data-jci-dropdown]');

      if (toggle) {
        event.preventDefault();
        toggleDropdown(toggle.closest('[data-jci-dropdown]'));
        return;
      }

      if (option) {
        event.preventDefault();
        setActivePanel(option.dataset.jciPanelIndex, option);
        closeDropdown(option.closest('[data-jci-dropdown]'));
        return;
      }

      if (!dropdown) closeAllDropdowns();
    });

    modal.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        if (modal.querySelector('[data-jci-dropdown].is-open')) {
          closeAllDropdowns();
          return;
        }

        close();
      }
    });

    modal.jciOpen = open;
    modal.jciClose = close;
  }

  function initModalTriggers(scope) {
    var context = scope || document;

    context.querySelectorAll('[data-jci-modal-open]').forEach(function (trigger) {
      if (trigger.dataset.jciModalTriggerInitialized === 'true') return;

      trigger.dataset.jciModalTriggerInitialized = 'true';
      trigger.addEventListener('click', function () {
        var modal = document.getElementById(trigger.dataset.jciModalOpen);

        if (!modal) return;
        initModal(modal);
        if (typeof modal.jciOpen === 'function') modal.jciOpen(trigger);
      });
    });
  }

  function resetMenuDrawerHash() {
    if (window.location.hash !== '#menu-drawer') return;

    window.history.replaceState(null, '', window.location.pathname + window.location.search);
    window.scrollTo(0, 0);
  }

  function initAll() {
    resetMenuDrawerHash();
    document.querySelectorAll(deliveryEstimateSelector).forEach(initDeliveryEstimate);
    document.querySelectorAll(gallerySelector).forEach(initGallery);
    document.querySelectorAll(stickyAtcSelector).forEach(initStickyAtc);
    document.querySelectorAll(selectorRootSelector).forEach(initSelector);
    document.querySelectorAll(modalSelector).forEach(initModal);
    initVariantOptionSelectSync(document);
    initModalTriggers(document);
    initCartCount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) return;
    event.target.querySelectorAll(deliveryEstimateSelector).forEach(initDeliveryEstimate);
    event.target.querySelectorAll(gallerySelector).forEach(initGallery);
    event.target.querySelectorAll(stickyAtcSelector).forEach(initStickyAtc);
    event.target.querySelectorAll(selectorRootSelector).forEach(initSelector);
    event.target.querySelectorAll(modalSelector).forEach(initModal);
    initVariantOptionSelectSync(document);
    initModalTriggers(event.target);
  });
})();
